import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { ANDROID_APP_LINK, IOS_APP_LINK } from "../../Utils/constants";
import EyesOnIcon from "../../assets/images/show.png";
import EyesOffIcon from "../../assets/images/hide.png";
import SuccessIcon from "../../assets/images/success-check.png";

import "./login.css";
import { changePasswordApi } from "../../API/ApiService";
import { loadingAction } from "../../Redux/Action/loadingAction";
import { useDispatch } from "react-redux";

function CreateNewPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  const [changeStatus, setChangeStatus] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [values, setValues] = useState({
    password: "",
    cpassword: "",
  });

  const [errors, setErrors] = useState({
    password: "",
    cpassword: "",
  });

  const [touched, setTouched] = useState({
    password: false,
    cpassword: false,
  });

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "password":
        if (!value) {
          error = "Password is required";
        } else if (value.length < 8) {
          error =
            "Password must be at least 8 characters with mix of letters, numbers & symbols";
        } else {
          const hasLetter = /[a-zA-Z]/.test(value);
          const hasSmallLetter = /[a-z]/.test(value);
          const hasCapitalLetter = /[A-Z]/.test(value);
          const hasNumber = /\d/.test(value);
          const hasSymbol = /[!@#$%&*]/.test(value);

          if (!hasLetter && !hasNumber && !hasSymbol) {
            error =
              "Password must be at least 8 characters with mix of letters, numbers & symbols";
          } else if (!hasSmallLetter) {
            error =
              "Password must contain a upper case letter, a lower case letter, a number and special characters(!@#$&%*) and at least 8 characters in length";
          } else if (!hasCapitalLetter) {
            error =
              "Password must contain a upper case letter, a lower case letter, a number and special characters(!@#$&%*) and at least 8 characters in length";
          } else if (!hasNumber) {
            error =
              "Password must contain a upper case letter, a lower case letter, a number and special characters(!@#$&%*) and at least 8 characters in length";
          } else if (!hasSymbol) {
            error =
              "Password must contain a upper case letter, a lower case letter, a number and special characters(!@#$&%*) and at least 8 characters in length";
          }
        }
        break;
      case "cpassword":
        if (!value) {
          error = "Please confirm your password";
        } else if (value !== values.password) {
          error = "Passwords do not match";
        }
        break;

      default:
        break;
    }

    return error;
  };

  const handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setValues({
      ...values,
      [name]: value,
    });
    if (touched[name]) {
      const error = validateField(name, value);
      setErrors({ ...errors, [name]: error });
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched({ ...touched, [name]: true });
    const error = validateField(name, value);
    setErrors({ ...errors, [name]: error });
  };

  const validateForm = () => {
    const formValues = { ...values };
    const newErrors = {};
    const newTouched = {};
    let isValid = true;

    Object.keys(formValues).forEach((key) => {
      newTouched[key] = true;
    });

    Object.keys(newTouched).forEach((key) => {
      const error = validateField(key, formValues[key]);
      newErrors[key] = error;
      if (error) isValid = false;
    });

    setErrors(newErrors);
    setTouched(newTouched);

    return isValid;
  };

  // ======= submit Login request ==============
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!validateForm()) {
      return;
    }

    dispatch(loadingAction(true));

    const password = values.password;
    const hasSmallLetter = /[a-z]/.test(password);
    const hasCapitalLetter = /[A-Z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSymbol = /[!@#$%&*]/.test(password);

    if (
      password.length < 8 ||
      !(hasSmallLetter && hasCapitalLetter && hasNumber && hasSymbol)
    ) {
      setErrorMsg(
        "Password must contain a upper case letter, a lower case letter, a number and special characters(!@#$&%*) and at least 8 characters in length"
      );
      dispatch(loadingAction(false));
      return;
    }

    if (values.password !== values.cpassword) {
      setErrorMsg("Password and Confirm Password do not match!");
      dispatch(loadingAction(false));
      return;
    } else {
      // navigate(/signinotp/${values?.email})
      let body = JSON.stringify({
        new_password: values.password,
      });
      try {
        const response = await changePasswordApi(body);
        const loginDataSuccess = response;

        if (loginDataSuccess) {
          dispatch(loadingAction(false));
          setChangeStatus(true);
        }
      } catch (err) {
        dispatch(loadingAction(false));
        setErrorMsg("An error occurred while changing password");
      }
    }
  };

  const togglePasswordVisibility = (val) => {
    if (val === "password") {
      setShowPassword(!showPassword);
    } else {
      setShowCPassword(!showCPassword);
    }
  };

  const [checkedVal, setCheckedVal] = useState("Business");
  const checkHandler = (event) => {
    setCheckedVal(event.target.value);
  };

  return (
    <>
      <div className="container login2 ">
        <div className="row">
          <div className="col-md-6 trust_sec">
            <h1>
              Your Trusted
              <br />
              Local Connection
              <br />{" "}
              <label
                style={{
                  color: "#349c52",
                  position: "relative",
                }}
              >
                Starts Here
                <img
                  src="images/green-suf.png"
                  className="key_feature_designg2"
                  alt=""
                  style={{ left: "3px" }}
                />
              </label>
            </h1>
            <div id="download_app">
              <div className="container login_download_app mt-1">
                <h6>
                  <img
                    src="images/suffixes3.svg"
                    className="suffixes3"
                    alt=""
                  />
                  Please Download and Install Brigiz App
                  <br />
                  to Explore More features{" "}
                  <img
                    src="images/green-suf2.png"
                    className="green-suf2"
                    style={{
                      width: "168px",
                      height: "32px",
                      marginLeft: "-158px",
                    }}
                    alt=""
                  />
                </h6>
              </div>
              <div className=" exp-download-btns mt-4">
                <button
                  onClick={() => window.open(ANDROID_APP_LINK, "_")}
                  style={{ background: "#292828" }}
                >
                  <div className="g_pay_container ">
                    <div className=" btn-img1">
                      <img src="images/play-button.svg" alt="" />
                    </div>
                    <div className=" btn-txt1">
                      <span>GET IT ON</span>
                      <p className="text-white m-0">Google Play</p>
                    </div>
                  </div>
                </button>
                <button
                  onClick={() => window.open(IOS_APP_LINK, "_")}
                  style={{ width: "180px", background: "#292828" }}
                >
                  <div className="g_pay_container">
                    <div className=" btn-img1">
                      <img src="images/apple.svg" />
                    </div>
                    <div className="col-md-9 btn-txt1">
                      <span>Download on the</span>
                      <p className="text-white m-0">App Store</p>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
          {!changeStatus ? (
            <div className="col-md-6 form_screen" id="create_new_password">
              <div className="login_card bg-white p-5 mt-1">
                <div className="login_back_btn">
                  {" "}
                  <button
                    href="#"
                    style={{ verticalAlign: "text-bottom" }}
                    onClick={() => navigate("/")}
                  >
                    <img src="images/back.png" alt="" /> Back
                  </button>
                </div>
                <form onSubmit={handleSubmit} className="login_form2">
                  <h4 className="login_form_label_2">Create New Password</h4>

                  <label className="login_form_email2 my-2">New Password</label>
                  <div className="password-input-container">
                    <input
                      className="login_form_input2"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={values.password}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                    />
                    <button
                      type="button"
                      className="password-toggle-btn bg-transparent"
                      onClick={() => togglePasswordVisibility("password")}
                    >
                      {showPassword ? (
                        <img src={EyesOnIcon} className="eyes-icon" alt="" />
                      ) : (
                        <img src={EyesOffIcon} className="eyes-icon" alt="" />
                      )}
                    </button>
                  </div>
                  {touched.password && errors.password ? (
                    <div className="text-danger small mt-1">
                      {errors.password}
                    </div>
                  ) : (
                    <div className="password_warning_text mb-2">
                      Password must contain a upper case letter, a lower case
                      letter, a number and special characters(!@#$&%*) and at
                      least 8 characters in length
                    </div>
                  )}
                  <label className="login_form_email2 my-2">
                    Confirm Password
                  </label>
                  <div className="password-input-container">
                    <input
                      className="login_form_input2"
                      type={showCPassword ? "text" : "password"}
                      name="cpassword"
                      value={values.cpassword}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                    />
                    <button
                      type="button"
                      className="password-toggle-btn bg-transparent"
                      onClick={() => togglePasswordVisibility("cpassword")}
                    >
                      {showCPassword ? (
                        <img src={EyesOnIcon} className="eyes-icon" alt="" />
                      ) : (
                        <img src={EyesOffIcon} className="eyes-icon" alt="" />
                      )}
                    </button>
                  </div>
                  {touched.cpassword && errors.cpassword && (
                    <div className="text-danger small mt-1">
                      {errors.cpassword}
                    </div>
                  )}
                  {errorMsg && (
                    <div className="text-danger small mt-1">{errorMsg}</div>
                  )}
                  <button
                    className="login_form_btn mt-4"
                    disabled={!checkedVal}
                    type="submit"
                  >
                    Next
                  </button>
                </form>
              </div>
            </div>
          ) : (
            <div className="col-md-6 form_screen" id="create_new_password">
              <div className="login_card bg-white p-5 mt-1">
                <div className="Success text-center">
                  <img src={SuccessIcon} alt="" />
                  <h4>Password Changed Successfully!</h4>
                </div>

                <button
                  className="login_form_btn mt-4"
                  onClick={() => navigate("/login")}
                >
                  Back To Sign In
                </button>
              </div>
            </div>
          )}
        </div>
        <div id="mobile_view">
          <div className="container login_download_app mt-1">
            <h6>
              <img src="images/suffixes3.svg" className="suffixes3" alt="" />
              Please Download and Install Brigiz App
              <br />
              to Explore More features{" "}
              <img
                src="images/green-suf2.png"
                className="green-suf2"
                style={{
                  width: "168px",
                  height: "32px",
                  marginLeft: "-158px",
                }}
                alt=""
              />
            </h6>
          </div>
          <div className=" exp-download-btns mt-4">
            <button
              onClick={() => window.open(ANDROID_APP_LINK, "_")}
              style={{ background: "#292828" }}
            >
              <div className="g_pay_container ">
                <div className=" btn-img1">
                  <img src="images/play-button.svg" alt="" />
                </div>
                <div className=" btn-txt1">
                  <span>GET IT ON</span>
                  <p className="text-white m-0">Google Play</p>
                </div>
              </div>
            </button>
            <button
              onClick={() => window.open(IOS_APP_LINK, "_")}
              style={{ width: "180px", background: "#292828" }}
            >
              <div className="g_pay_container">
                <div className=" btn-img1">
                  <img src="images/apple.svg" />
                </div>
                <div className="col-md-9 btn-txt1">
                  <span>Download on the</span>
                  <p className="text-white m-0">App Store</p>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CreateNewPassword;
